<template>
    <div class="tooltip">
        {{ tooltip }}<span class="tooltip-text" :class="position">{{ tooltipText }}</span>
    </div>
</template>

<script>
export default {
    props: {
        tooltip: String,
        tooltipText: String,
        position: String,
    },
};
</script>

<style lang="scss">
$tooltip-arrow-size: 5px;
$tooltip-width-size: 120px;
$tooltip-background-color: rgba(42, 42, 42, 0.9);

.tooltip {
    position: relative;

    &:hover .tooltip-text {
        visibility: visible;
        opacity: 1;
    }

    .tooltip-text {
        visibility: hidden;
        width: 120px;
        background-color: $tooltip-background-color;
        color: #ffffff;
        text-align: center;
        text-transform: none;
        padding: 5px 0;
        border-radius: 6px;

        /* Position the tooltip text - see examples below! */
        position: absolute;
        z-index: 1;

        opacity: 0;
        transition: opacity 1s;

        &.right {
            top: -5px;
            left: 105%;
            margin-left: $tooltip-arrow-size;

            &:after {
                content: ' ';
                position: absolute;
                top: 50%;
                right: 100%; /* To the left of the tooltip */
                margin-top: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: transparent $tooltip-background-color transparent transparent;
            }
        }

        &.left {
            top: -5px;
            right: 105%;
            margin-right: $tooltip-arrow-size;

            &:after {
                content: ' ';
                position: absolute;
                top: 50%;
                left: 100%; /* To the right of the tooltip */
                margin-top: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: transparent transparent transparent $tooltip-background-color;
            }
        }

        &.top {
            width: $tooltip-width-size;
            bottom: 100%;
            left: 50%;
            margin-left: -60px; /* Use half of the width (120/2 = 60), to center the tooltip */
            margin-bottom: $tooltip-arrow-size;

            &:after {
                content: ' ';
                position: absolute;
                top: 100%; /* At the bottom of the tooltip */
                left: 50%;
                margin-left: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: $tooltip-background-color transparent transparent transparent;
            }
        }

        &.bottom {
            width: 120px;
            top: 100%;
            left: 50%;
            margin-left: -60px; /* Use half of the width (120/2 = 60), to center the tooltip */
            margin-top: $tooltip-arrow-size;

            &:after {
                content: ' ';
                position: absolute;
                bottom: 100%; /* At the top of the tooltip */
                left: 50%;
                margin-left: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: transparent transparent $tooltip-background-color transparent;
            }
        }
    }
}
</style>
